import * as types from './types'

const initialState={
  items: {},
  fetchStatus: {
    ProductHuntIsFetching: false,
    ProductHuntIsRejected: false,
    HackerNewsIsFetching: false,
    HackerNewsIsRejected: false,
    DesignerNewsIsFetching: false,
    DesignerNewsIsRejected: false,
    EchoJSIsFetching: false,
    EchoJSIsRejected: false,
  }
}

export default function posts (state=initialState, action) {
  switch (action.type) {
    // receiving dynamic keyhash variables to dispatch actions to reducers
    case (types.RECEIVE_FEEDS):
      return {
        ...state,
        [`${action.name}Homepage`]: action[`${action.name}Homepage`],
        items: {
          ...state.items,
          [`${action.name}Items`]: action[`${action.name}Items`]
        },
        fetchStatus: Object.assign({},
          state.fetchStatus, {
          [`${action.name}IsFetching`]: action[`${action.name}IsFetching`],
          [`${action.name}IsRejected`]: action[`${action.name}IsRejected`]
        }),
      }
    
    case (types.REQUEST_FEEDS):
      return {
        ...state,
        fetchStatus: Object.assign({}, state.fetchStatus, {
          [`${action.name}IsFetching`]: action[`${action.name}IsFetching`],
          [`${action.name}IsRejected`]: action[`${action.name}IsRejected`]
        }),
      }
    
    case (types.REJECT_FEEDS):
      return {
        ...state,
        fetchStatus: Object.assign({}, state.fetchStatus, {
          [`${action.name}IsFetching`]: action[`${action.name}IsFetching`],
          [`${action.name}IsRejected`]: action[`${action.name}IsRejected`]
        }),
        errorMessage: action.errorMessage
      }
    
    default:
      return state;
  }
}